/*
 * @Author: tkp
 * @Date: 2021-11-20 16:39:42
 */
export function setting() {
    let baseUrl = '';
    if (process.env.NODE_ENV == 'development') {
        baseUrl = 'http://192.168.1.232:8083';
    } else if (process.env.NODE_ENV == 'testing') {
        baseUrl = 'https://www.chuangfuzhi.cn';
    } else if (process.env.NODE_ENV == 'preview') {
        baseUrl = 'https://www.chuangfuzhi.cn';
    } else if (process.env.NODE_ENV == 'production') {
        baseUrl = 'https://www.chuangfuzhi.cn';
    }
    return baseUrl
}
// -1 异常   0 正常  1 失败   -9 失效
export const code_status = {
    SUCCESS: '0',
    ERROR: '-1',
    FAIL: '1',
    PASSTOKEN: '-9'
}


// WEBPACK FOOTER //
// ./src/utils/setting.js